module.exports = __webpack_public_path__ + "static/bg-6f93f4d2be141cacd756b0ce912ffdfb.jpg";